import { COLOURS } from '../../../../../../../../../ui-kit/common/styles/vars';

const {
  green: { lightGreen },
  userComment: { cerulean },
  yellow: { lightYellow },
  grey: { grayBrown }
} = COLOURS;











export const labelConfig = {
  PUBLIC: {
    bgColor: lightGreen,
    textColor: cerulean
  },
  INTERNAL: {
    bgColor: lightYellow,
    textColor: grayBrown
  },
  SHOOTSTA_INTERNAL: {
    bgColor: lightYellow,
    textColor: grayBrown
  }
};